/* eslint-disable no-param-reassign */
import { getCollections } from '@/datalayer/helpers/collections';
import { getAttributes } from '@/datalayer/helpers/attributes';

const initialState = () => ({
  categories: [],
  // collection slugs that live on /
  root_level_collections: [],
  // collections slugs that are browsable
  static_collections: [],
  dynamic_collections: [],
  attributes: [],
  valid_attributes: [],
});

export { initialState as state };

export const mutations = {
  set(state, data) {
    state.attributes = data.attributes;
    // root level collection slugs
    state.root_level_collections = data.collections
      .filter((c) => c.root_level === true)
      .map((c) => c.slug);
    // browsable static collection slugs
    state.static_collections = data.collections
      .filter((c) => !c.is_dynamic_collection && !c.root_level)
      .map((c) => c.slug);
    state.dynamic_collections = data.collections
      .filter((c) => c.is_dynamic_collection)
      .map((c) => c.slug);

    state.valid_attributes = data.attributes.map((a) => {
      const attr = {
        slug: a.slug,
        type: a.type,
      };

      if (['enumeration'].includes(a.type)) {
        attr.multiple = (a.type_options && a.type_options.multiple);
        attr.options = a.type_options.options.map((o) => o.value);
      }

      return attr;
    });
  },
};

export const actions = {
  async fetch({ commit }) {
    const [collections, attributes] = await Promise.all([
      getCollections(this.$cachios),
      getAttributes(this.$cachios),
    ]);

    commit('set', {
      collections,
      attributes,
    });
  },
};
